import { IVoiceBlaster } from '../shared/types/voiceBlaster';
import { apiService } from './index';

export const asyncGetVoiceBlaster = async (
    page?: number,
    pageSize?: number
) => {
    return await apiService.get('/api/voice-blaster', {
        limit: pageSize || '',
        page: page || '',
    });
};

export const asyncGetLatestVoiceBlaster =
    async (): Promise<IVoiceBlaster | null> => {
        try {
            const response = await apiService.get<{ items: IVoiceBlaster }>(
                '/api/voice-blaster/latest'
            );
            return response?.items || null;
        } catch (error) {
            return null;
        }
    };

export const asyncPostVoiceBlaster = async (formMessage: IVoiceBlaster) => {
    return await apiService.post('/api/voice-blaster', formMessage);
};
